import React, { Component } from 'react';
import Slider from "react-slick";
import './slice.css';

const Slice = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
  focusOnSelect:true
  };
    return (
<div className="imagen">
      <Slider {...settings} className="sliceRoot">
        <div>
        <img src={require('../../resources/images/project/verdindung/01.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/02.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/03.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/04.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/05.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/06.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/07.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/08.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/09.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/10.png')} className='imagenPrincipal'/>
        </div>
        <div>
          <img src={require('../../resources/images/project/verdindung/11.png')} className='imagenPrincipal'/>
        </div>
      </Slider>
    </div>
    )
}
export default Slice



// WEBPACK FOOTER //
// ./src/projects/Verbingdung/slice.js